import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import loginImg from "assets/images/loginImg.png";
import sabadiLog from "assets/images/logo-sabadi.png";
import { connection } from "utils/apiConnection.ts";
import loginimg from "assets/images/LogoMotion.png";
import logobgorange from "assets/images/logobgorange.PNG";
import Lottie from "react-lottie-player";
import Login_LogoMotion from "./Login_LogoMotion.json";

export default function LogInNumber({ ChangeModal, login, SetNumber, number }) {
  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);
  useEffect(() => {
    (() => {
      "use strict";

      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      const forms = document.querySelectorAll(".needs-validation");
      // Loop over them and prevent submission
      Array.prototype.slice.call(forms).forEach((form) => {
        form.addEventListener(
          "submit",
          (event) => {
            if (!form.checkValidity()) {
              event.preventDefault();
              event.stopPropagation();
            }
            form.classList.add("was-validated");
          },
          false
        );
      });
    })();
  }, []);

  let SendNumber = (e) => {
    e.preventDefault();
    const pattern = /^09\d{9}$/;

    if (!pattern.test(number)) {
      setIsPhoneNumberValid(false);
      return "";
    }
    setIsPhoneNumberValid(true);

    // formData.append("step", "1");

    connection("api/getlogincode", { mobile: number })
      .then((data) => {
        if (data.status == 1) {
          ChangeModal(1);
          login(data.data.hashcode);
        } else if (data.status == 0) {
          Swal.fire({
            title: "خطا!",
            text: "لطفا دوباره امتحان کنید",
            type: "error",
            confirmButtonText: "باشه",
          });
        } else if (data.status == -1) {
          Swal.fire({
            title: "خطا!",
            text: "شما مجاز نیستید",
            type: "error",
            confirmButtonText: "باشه",
          });
        }
      })
      .catch((error) => {
        ChangeModal(1);
        login("gg");
        Swal.fire({
          title: "خطا",
          text: "لطفا دوباره امتحان کنید",
          type: "error",
          confirmButtonText: "باشه",
        });
      });
  };

  return (
    <form
      className="needs-validation Login-number"
      noValidate
      onSubmit={SendNumber}
    >
      <div style={{ backgroundColor: "#f1eae5" }}>
        <div className="d-flex flex-column "></div>
        {/* <div className="d-flex login-container  flex-column align-items-center justify-content-evenly ">
          <img src={sabadiLog} className="logo-login" />
          <h4 className="title-login">ورود یا ثبت نام در سبدی</h4>
          <p className="text-center text-login">
            برای ورود به سبدی شماره همراه خود را وارد کنید.
          </p>
          <input
            onChange={SetNumber}
            value={number}
            type="tel"
            style={{
              height: "50px",
              borderRadius: "15px",
              direction: "ltr",
              fontFamily: "digits",
              marginTop: "-10px ",
              marginBottom: "-10px ",
            }}
            id="number"
            placeholder="09*********"
            className="form-control w-75 mx-auto"
            required
          />
          {!isPhoneNumberValid && (
            <div
              style={{
                color: "red",
                fontSize: "12px",
                textAlign: "right",
                margin: "5px 60px 0px 0px",
              }}
            >
              شماره وارد شده اشتباه است.
            </div>
          )}

          <button
            onClick={SendNumber}
            style={{
              height: "50px",
              borderRadius: "15px",
              backgroundColor: "#1A3764",
              color: "white",
            }}
            className="btn  mb-3 w-75"
          >
            ادامه
          </button>
        </div> */}
        <div className=" d-flex justify-content-evenly container-login p-3">
          <div
            className="parent-login"
            style={{
              width: "320px",
              height: "400px",
              backgroundColor: "white",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "100px",
                backgroundColor: "#ff4734",
                position: "relative",
                borderRadius: " 25px 25px 0px 0px",
                textAlign: "center",
              }}
            >
              <img
                src={logobgorange}
                style={{ width: "200px", height: "100px" }}
              ></img>
            </div>
            <div className="row px-4 pt-3 mt-2">
              <div className="w-75">
                <label style={{ fontSize: "17px", fontWeight: "bold" }}>
                  موبایل
                </label>
              </div>
              <div>
                <input
                  onChange={SetNumber}
                  value={number}
                  type="tel"
                  style={{
                    backgroundColor: "#f1eae5",
                    width: "100%",
                    outline: "none",
                    borderRadius: " 13px",
                    border: "1px solid #fff ",
                    padding: "3px",
                    marginBottomgin: "7px",
                    padding: "15px",
                  }}
                  id="number"
                  placeholder="09*********"
                  className="form-control mt-2 mx-auto"
                  required
                />
                {!isPhoneNumberValid && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "12px",
                      textAlign: "right",
                      margin: "5px 60px 0px 0px",
                    }}
                  >
                    شماره وارد شده اشتباه است.
                  </div>
                )}
                <label
                  htmlFor="number"
                  className="text-start  d-block my-3"
                  style={{ marginRight: "55px", color: "#1D3354" }}
                >
                  شماره همراه خود را وارد کنید.
                </label>
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-end px-3 mt-5 ">
              <div className="w-100" style={{ textAlign: "center" }}>
                <button
                  onClick={SendNumber}
                  className="btn-log mb-3 w-75 mx-auto"
                >
                  ورود
                </button>
              </div>
            </div>
          </div>
          <Lottie
            className="img-login"
            loop
            animationData={Login_LogoMotion}
            play
          />
        </div>
      </div>
    </form>
  );
}
